import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

class Form extends Component {
    renderField = data => {
        data.input.className = 'form-control';

        const isInvalid = data.meta.touched && !!data.meta.error;
        if (isInvalid) {
            data.input.className += ' is-invalid';
            data.input['aria-invalid'] = true;
        }

        if (this.props.error && data.meta.touched && !data.meta.error) {
            data.input.className += ' is-valid';
        }

        return (
            <div className={`form-group`}>
                <label
                    htmlFor={`song_${data.input.name}`}
                    className="form-control-label"
                >
                    {data.input.name}
                </label>
                {data.type === 'textarea' && (
                    <textarea
                        {...data.input}
                        required={data.required}
                        placeholder={data.placeholder}
                        id={`song_${data.input.name}`}
                        style={data.style}
                    />
                )}
                {data.type !== 'textarea' && (
                    <input
                        {...data.input}
                        type={data.type}
                        step={data.step}
                        required={data.required}
                        placeholder={data.placeholder}
                        id={`song_${data.input.name}`}
                    />
                )}
                {isInvalid && (
                    <div className="invalid-feedback">{data.meta.error}</div>
                )}
            </div>
        );
    };

    render() {
        const { handleSubmit } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <Field
                    component={this.renderField}
                    name="title"
                    type="text"
                    placeholder=""
                    required={true}
                />
                <Field
                    component={this.renderField}
                    name="chords"
                    type="textarea"
                    placeholder=""
                    required={true}
                    style={{ fontFamily: 'monospace' }}
                />

                <button type="submit" className="btn btn-success">
                    Submit
                </button>
            </form>
        );
    }
}

export default reduxForm({
    form: 'song',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
})(Form);



// WEBPACK FOOTER //
// ./src/components/song/Form.js